import React, {createContext, useReducer} from "react";

const LoadingContext = createContext();

const initialState = {
  loading: true,
  showIndicator: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "toggle":
      return {
        ...state,
        loading: !state.loading,
      };
    case "set":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

function LoadingContextProvider(props) {
  const [loading, loadingDispatch] = useReducer(reducer, initialState);
  const value = {loading, loadingDispatch};

  return <LoadingContext.Provider value={value}>{props.children}</LoadingContext.Provider>;
}

const LoadingContextConsumer = LoadingContext.Consumer;

export {LoadingContext, LoadingContextProvider, LoadingContextConsumer};
